<template>
  <div style="background: #fff;">
    <div id="singleModule">
      <div class="moduleContainer">
        <el-row class="phoneContact">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="box">
            <div class="name">峰会咨询</div>
            <div class="list">
              <div class="item">
                <i class="iconfont icon-lianxiren"></i>
                <span class="label">联系人</span>
                <span class="value">Roy 罗龑</span>
              </div>
              <div class="item">
                <i class="iconfont icon-lianxifangshi"></i>
                <span class="label">电话</span>
                <span class="value">+86-21-38452013</span>
              </div>
              <div class="item">
                <i class="iconfont icon-youxiang"></i>
                <span class="label">邮箱</span>
                <span class="value">roy0801@qq.com</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="box">
            <div class="name">注册咨询</div>
            <div class="list">
              <div class="item">
                <i class="iconfont icon-lianxiren"></i>
                <span class="label">联系人</span>
                <span class="value">Jenny 张雷</span>
              </div>
              <div class="item">
                <i class="iconfont icon-lianxifangshi"></i>
                <span class="label">电话</span>
                <span class="value">+86-21-68903563*50</span>
              </div>
              <div class="item">
                <i class="iconfont icon-youxiang"></i>
                <span class="label">邮箱</span>
                <span class="value">jennyz@infosalons.com.cn</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'wmt-contactDetail',

  data() {
    return {

    };
  },

  mounted() {

  },
  
  methods: {

  },
};
</script>

<style lang="less" scoped>
#singleModule {
  height: auto !important;
  background: #f7f7f7 !important;
}
.phoneContact{
  background: #fff;
  // height: 440px;
  margin-top: 14px;
  padding: 0 20px 20px;
  text-align: left;
  .box {
    padding-top: 20px;
    padding-left: 14px;
    .name {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 10px;
      color: #333333;
    }
    .item {
      margin-top: 15px;
      .iconfont {
        font-size: 20px;
        color: #2aaed9;
      }
      .label {
        font-size: 15px;
        font-weight: 400;
        width: 50px;
        display: inline-block;
        color: #333333;
        margin: 0 10px 0 4px;
      }
      .value {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
.contactBox {
  background: #fff;
  height: 440px;
  margin-top: 105px;
  .box {
    padding-top: 114px;
    padding-left: 200px;
    .name {
      font-size: 22px;
      font-weight: 500;
      color: #333333;
    }
    .item {
      margin-top: 40px;
      .iconfont {
        font-size: 20px;
        color: #2aaed9;
      }
      .label {
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        margin: 0 28px 0 17px;
      }
      .value {
        font-size: 18px;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>